const DefaultPaginationOptions = [25, 50, 100];

export default DefaultPaginationOptions;
